module.exports = __webpack_public_path__ + "img/3_157.2fed44ff.png";